(() => {
  window.swinger.observer.initialize([
    '.swinger-image .swinger-image__lazy-load',
    '.swinger-image img[loading="lazy"]',
  ].map((selector) => `.swinger-navigation-item ${selector}`).join(','), (elem) => {
    const image = elem.closest('.swinger-image');

    window.setTimeout(() => {
      window.requestIdleCallback(() => {
        if (
          !elem
          || !image
          || !elem.isConnected
          || !image.isConnected
        ) {
          return;
        }

        window.swinger.eventHub.trigger(image, 'swinger-image:load');
      }, {
        timeout: 3000,
      });
    }, 3000);
  }, false);

  window.swinger.eventHub.register('mousedown', '.swinger-navigation-item__link--show-all[href]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    window.location = elem.href;
  });
})();
